<div class="compliance-container" [class.no-min-height]="noMinHeight">
    <app-only-table-generator
        [tableInput]="tableGenInput"
        [tableData]="severityCount"
        [hideControlBar]="true"
    >
    </app-only-table-generator>
</div>
